import React, { useState, useEffect } from "react";
import { useUI } from "../../context/UIContext";
import { ReportAPI } from "../../api/apiClient";

interface EquipmentStatementRow {
  component?: string;
}

export default function EquipmentStatementReport() {
  const { selectedProjectId } = useUI();

  const [data, setData] = useState<EquipmentStatementRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReport = async () => {
      if (!selectedProjectId) return;

      setLoading(true);

      try {
        const result = await ReportAPI.getEquipmentStatementDashboard({
          project: selectedProjectId,
          vendor: -1,
          cmp: 0,
        });

        setData(result);
      } catch (err) {
        console.error(err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [selectedProjectId]);

  const components = data
    .map((d) => d.component || "Unknown")
    .filter((value, index, self) => self.indexOf(value) === index);

  /*return (
    <div className="w-full">

      <div className="bg-white rounded-lg shadow-md overflow-hidden">

       
        <div className="bg-blue-700 text-white px-6 py-3 font-semibold text-lg">
          MACHINES HIRED
        </div>

        
        <div className="bg-gray-100 px-6 py-8 rounded-b-lg">

          {loading ? (
            <div className="text-center text-blue-600">
              Loading...
            </div>
          ) : components.length > 0 ? (
            <>
              <div className="text-gray-700 text-base mb-6">
                {components[0]}
              </div>

              <div className="text-center text-gray-600 text-sm">
                Hours
              </div>
            </>
          ) : (
            <div className="text-center text-gray-500 font-medium">
              No Data Available
            </div>
          )}

        </div>

      </div>

    </div>
  );
}*/
return (
  <div className="w-full">
    <div className="bg-white rounded-lg shadow-md overflow-hidden">

      {/* Header */}
    {/*  <div className="bg-blue-700 text-white px-6 py-3 font-semibold text-lg">*/}
         <div className="bg-[#1788ac] text-white px-6 py-3 font-semibold text-lg">
        MACHINES HIRED  
      </div>

      {/* Body */}
      <div className="bg-white px-6 py-8 rounded-b-lg">

        {loading ? (
          <div className="text-center text-blue-600">
            Loading...
          </div>
        ) : components.length > 0 ? (
          <>
            <div className="text-gray-700 text-base mb-6">
              {components[0]}
            </div>

            <div className="text-center text-gray-600 text-sm">
              Hours
            </div>
          </>
        ) : (
          <div className="text-center text-gray-500 font-medium">
            No Data Available
          </div>
        )}

      </div>
    </div>
  </div>
);
}